import React from 'react';
import _ from 'lodash';
import { useTranslation } from 'react-i18next';
import { Table } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch, faLongArrowAltUp ,faLongArrowAltDown } from '@fortawesome/free-solid-svg-icons';
import Dropdown from './Dropdown';

const CustomTable = ({
  columns,
  datas,
}) => {
  const { t } = useTranslation();

  const dataParser = (column, data, index) => {
    switch(column.key) {
      case 'view':
        return (
          <td key={index} className='action-button'>
            <span onClick={() => column.moveToPage.func(...column.moveToPage.params.map((param) => _.get(data, param)))}>
            {/* <span onClick={() => column.moveToPage.func(data[column.moveToPage.params])}> */}
              <FontAwesomeIcon icon={faSearch}/>
            </span>
          </td>
        )
      case 'button':
        return (
          <td key={index}>
            <Dropdown
              column={column}
              data={data}
            />
          </td>
        )
      case 'status':
        return (
          <td key={index}>
            <span className={`status-${data.status}`}>
              {column.formatter ? column.formatter.func(...column.formatter.params.map((param) => _.get(data, param)))
              : data.status}
            </span>
          </td>
        )
      case 'rooms':
        return (
          <td key={index}>
            <div className='wrap-overlay w-70'>
              <span className='overlay-key'>{column.formatter.func(...column.formatter.params.map((param) => _.get(data, param)))}</span>
              <span className='overlay-item'>{column.formatter.func(...column.formatter.params.map((param) => _.get(data, param)))}</span>
            </div>
          </td>
        )
      case 'log_message':
        return (
          <td key={index}>
            <div className='wrap-overlay'>
              <span className='overlay-key'>{column.formatter.func(...column.formatter.params.map((param) => _.get(data, param)))}</span>
              <span className='overlay-item'>{data.log_message}</span>
            </div>
          </td>
        )
      default:
        return (
          <td key={index}>
            {_.get(data, column.key) ? (
              <span
                className={column.linker ? 'link-detail' : ''}
                onClick={() => column.linker ? column.linker.func(...column.linker.params.map((param) => _.get(data, param))) : ''}
              >
                {column.formatter ? column.formatter.func(...column.formatter.params.map((param) => _.get(data, param))) : _.get(data, column.key)}
              </span>
            ) : (
              _.isNumber(data[column.key]) ? 0 : '-'
            )}
          </td>
        )
    }
  };

  return (
    <Table>
      <thead>
        <tr>
          {columns.map((column, index) =>
            <th key={index} width={column.width}>
              {column.sort ? (
                <span className='c-pointer' onClick={() => column.sort.func(column.sort.params)}>
                  {column.text}
                  <FontAwesomeIcon
                    className={`ml-5 ${column.sort.selected ? 'c-blue':'d-none'}`}
                    icon={column.sort.order === 'desc' ? faLongArrowAltDown : faLongArrowAltUp}
                  />
                </span>
              ) : (
                <span>{column.text}</span>
              )}
            </th>
          )}
        </tr>
      </thead>
      <tbody>
        {datas.length > 0 ? datas.map((item, index) => (
          <tr key={index}>
            {columns.map((column, index) => dataParser(column, item, index))}
          </tr>
        )) : (
          <tr>
            <td className='no-list-data' colSpan={columns.length}>
              {t('error_message.no_data')}
            </td>
          </tr>
        )}
      </tbody>
    </Table>
  );
};

export default CustomTable;